'use es6';

export const PRIMARY_CSS_PATH = 'custom/styles/default/hs_default_custom_style.css';
export const PRIMARY_CSS_FILENAME = 'hs_default_custom_style.css';
export const PRIMARY_CSS_LABEL = 'Primary CSS File';